
import * as cloudflareRuntime$Bv1VSBrXSk from '/home/circleci/project/node_modules/.pnpm/@nuxt+image@1.8.1_magicast@0.5.5/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$Bv1VSBrXSk, defaults: {"baseURL":"https://o7web.com","modifiers":{"format":"auto"}} }
}
        